'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _reactNativePublicIp = require('react-native-public-ip');

var _reactNativePublicIp2 = _interopRequireDefault(_reactNativePublicIp);

var _post2 = require('./post');

var _post3 = _interopRequireDefault(_post2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @param type
 * @param id
 * @param meta
 * @param isMobile
 * @param isFail
 * @param isProduction
 * @returns {Promise<void>}
 */
async function log(type, id, meta, isMobile, isFail, isProduction) {
    var _post;

    if (isProduction === undefined) {
        throw 'Missing isProduction flag.';
    }

    if (id === null || (typeof id === 'undefined' ? 'undefined' : _typeof(id)) !== 'object') {
        throw 'The event user-type id must be an object.';
    }

    var idType = Object.keys(id)[0];

    var ip = await (0, _reactNativePublicIp2.default)();

    /**
     * Send request to API Gateway
     */
    return await (0, _post3.default)((_post = {
        type: type.toLowerCase()
    }, _defineProperty(_post, idType, id[idType]), _defineProperty(_post, 'idType', idType), _defineProperty(_post, 'isMobile', isMobile || false), _defineProperty(_post, 'eventTime', Math.floor(Date.now() / 1000)), _defineProperty(_post, 'isProduction', isProduction), _defineProperty(_post, 'ip', ip), _defineProperty(_post, 'meta', meta), _post));
}

exports.default = log;